@if (!loading()) {
<div class="flex items-center gap-2" [class.pointer-events-none]="disabled()">
  <div
    tabindex="0"
    class="inline-block relative w-12 h-6 align-middle rounded-full select-none cursor-pointer group focus:outline-none"
    [class]="{
        'bg-secondary/30': !checked() && !disabled(),
        'bg-secondary/10': !checked() && disabled(),
        'bg-primary/50': checked() && !disabled(),
        'bg-secondary/15': checked() && disabled(),
      }"
    (keyup.enter)="toggle()"
    (keyup.space)="toggle()"
    (click)="toggle()"
  >
    <input
      tabindex="-1"
      type="checkbox"
      [checked]="checked()"
      (change)="toggle()"
      [disabled]="disabled()"
      [attr.data-testid]="id()"
      [id]="id()"
      class="absolute pointer-events-none! z-10 inset-1 block w-4 h-4 rounded-full bg-secondary appearance-none focus:outline-none transition-transform duration-300 ease-in-out cursor-pointer group-active:border-primary-800 group-focus:border-primary-800"
      [class]="{
          'border-secondary/10': disabled(),
          'border-secondary ': !disabled(),
          'bg-primary': checked(),
          'bg-secondary': !checked(),
        }"
      [@slideRight]="checked() ? 'active' : 'inactive'"
    />

    <span
      class="flex absolute left-1 top-1 text-xs text-secondary-600 opacity-80 pointer-events-none"
    >
      <ng-content select="[tvdToggleOff]" />
    </span>

    <span
      class="flex absolute right-1 top-1 text-xs text-secondary-600 opacity-80 pointer-events-none"
    >
      <ng-content select="[tvdToggleOn]" />
    </span>
    <!-- Optional icons inside the track -->
    @if (iconOff(); as icon) {
    <span
      class="flex absolute left-1 top-1 text-secondary-600 opacity-80 pointer-events-none"
    >
      <tvd-icon [icon]="icon" size="sm" class="text-background" />
    </span>
    } @if (iconOn(); as icon) {
    <span
      class="flex absolute right-1 top-1 text-secondary-600 opacity-80 pointer-events-none"
    >
      <tvd-icon [icon]="icon" size="sm" />
    </span>
    }
  </div>
  <label
    (click)="toggle()"
    class="block pl-md text-sm cursor-pointer pt-px"
    [class]="{
        'text-primary': !disabled(),
        'text-neutrals': disabled(),
      }"
    [htmlFor]="id()"
    ><ng-content
  /></label>
</div>
} @else {
<div class="skeleton w-full max-w-xs"></div>
}

<ng-template #skeleton>
  <div class="skeleton w-full max-w-xs"></div>
</ng-template>
